import React, { Component } from "react";
import { loading, t } from "../components/CustomComponent.js";
import Language from "../components/Language.js";
import "../components/global.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

// หน้าเข้าพอร์ทัลลูกค้าด้วยเลขผู้เสียภาษี 13 หลัก + รหัสสาขา (ช่องเดียว ไม่มีรหัสผ่าน) - หน้าสาธารณะ
// เรียก fetch ตรง ๆ แทน POST ของ services/api.js เพราะตัวนั้นแนบ Authorization/company-uid
// และสั่ง localStorage.clear() + เด้งไป "/" เมื่อเจอ token หมดอายุ ซึ่งไม่เข้ากับหน้านี้
const API_BASE = process.env.REACT_APP_API_URL;

export default class CustomerPortalLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
      submitting: false,
      // ข้อความ error เดียวสำหรับทุกกรณีที่เข้าไม่ได้ - ห้ามบอกว่าเลขถูกแต่สาขาผิด
      error_key: "",
      expired: new URLSearchParams(window.location.search).get("expired") === "1",
    };
  }

  componentDidMount() {
    loading(false);
  }

  handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const code = this.state.code.trim();
    if (!code) {
      this.setState({ error_key: "customer_portal_login_failed", expired: false });
      return;
    }

    this.setState({ submitting: true, error_key: "", expired: false });
    try {
      const res = await fetch(`${API_BASE}public/customer-portal/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json", accept: "application/json" },
        cache: "no-cache",
        body: JSON.stringify({ code }),
      });
      let json = null;
      try {
        json = await res.json();
      } catch (err) {
        json = null;
      }

      const data = json?.data;
      if (!res.ok || json?.status !== true || !data?.token) {
        // ทุกกรณี (ไม่พบ / รูปแบบผิด / ถูกล็อก / ยิงเกินกำหนด) แสดงข้อความกลางเหมือนกัน
        this.setState({ error_key: "customer_portal_login_failed", submitting: false });
        return;
      }

      // สิทธิ์เมนูมาจากบทบาทเริ่มต้นของลูกค้าของบริษัทนั้น (backend ส่งมาใน data.role.permission)
      // ปิดเมนูที่หน้าจัดการบทบาทแล้วทางนี้ก็หายตามจริง - ไม่ใช่เปิดทุกเมนูตายตัวแบบเดิม
      // ธง portal_limited ใช้แยกจากผู้ใช้ปกติ (ข้ามการเรียก admin/users/profile, logout, ป้ายโหมดจำกัด, 401 -> กลับหน้านี้)
      const permission = Array.isArray(data.role?.permission) ? data.role.permission : [];
      const firstLink = global.getFirstAccessibleLink(global.menu_customer, permission);

      // บริษัทปิดเมนูของลูกค้าไว้หมด -> เข้าไปก็ไม่มีหน้าให้ดู บอกตรง ๆ ดีกว่าเด้งไปหน้า 403
      if (!firstLink) {
        this.setState({ error_key: "customer_portal_no_menu", submitting: false });
        return;
      }
      localStorage.setItem("cm-acc-tk", btoa("Bearer " + data.token));
      localStorage.setItem(
        "cm-company",
        JSON.stringify({ id: data.company?.uid || "", name: data.company?.name || "", code: "" }),
      );
      localStorage.setItem(
        "cm-profile",
        JSON.stringify({
          user_type: "customer",
          portal_limited: true,
          full_name: data.customer?.name || "",
          customer: data.customer || null,
          company: data.company || null,
          token_expires: data.token_expires || null,
          role: { name: data.role?.name || t("customer_portal_role_name"), permission },
        }),
      );
      window.location.href = firstLink;
    } catch (err) {
      this.setState({ error_key: "customer_portal_login_network_error", submitting: false });
    }
  };

  render() {
    const { code, submitting, error_key, expired } = this.state;

    return (
      <div className="w-100 min-vh-100 d-flex align-items-center justify-content-center p-3" style={{ backgroundColor: "#F4F7FE" }}>
        <div className="w-100" style={{ maxWidth: "460px" }}>
          <div className="d-flex justify-content-end mb-2">
            <Language />
          </div>
          <form className="bg-white rounded-4 shadow-sm p-4" onSubmit={this.handleSubmit} noValidate>
            <div className="text-center mb-3">
              <img src={LOGO} alt="logo" height={36} style={{ objectFit: "contain" }} />
            </div>
            <h4 className="fw-bold text-center mb-1">{t("customer_portal_login_title")}</h4>
            <p className="text-secondary text-14 text-center mb-4">{t("customer_portal_login_desc")}</p>

            {expired && !error_key && (
              <div className="alert alert-warning text-13 py-2" role="alert">{t("customer_portal_session_expired")}</div>
            )}

            <label htmlFor="customer-portal-code" className="form-label text-13 text-secondary">
              {t("customer_portal_code_label")}
            </label>
            <input
              id="customer-portal-code"
              type="text"
              inputMode="text"
              autoComplete="off"
              autoFocus
              className={`form-control form-control-lg rounded-3 ${error_key ? "is-invalid" : ""}`}
              placeholder="1234567890123-00000"
              maxLength={30}
              value={code}
              disabled={submitting}
              onChange={(e) => this.setState({ code: e.target.value })}
              aria-describedby="customer-portal-hint"
            />
            {error_key && (
              <div className="text-danger text-13 mt-2" role="alert">{t(error_key)}</div>
            )}
            <div id="customer-portal-hint" className="text-secondary text-12 mt-2 mb-4">
              {t("customer_portal_code_hint")}
            </div>

            <button type="submit" className="btn btn-primary w-100 py-2 fw-bold rounded-3" disabled={submitting}>
              {t("customer_portal_login_submit")}
            </button>
            <div className="text-secondary text-12 text-center mt-3">{t("customer_portal_limited_notice")}</div>
          </form>
        </div>
      </div>
    );
  }
}
